export default {
  "HitPaw Add Music to Audio Online": "HitPaw Agregar Música a Audio Online",
  "Add BGM to Audio without any difficulties.": "Agrega BGM al audio sin ninguna dificultad.",
  "Add New": "Agregar nuevo",
  "Format": "Formato",
  "Add tracks": "Agregar pistas",
  
};
